import { measureUnitValueConvertor } from '../Table/components/SimpleFilter/helpers/filterValueConvertors/measureUnitValueConvertor';

export type FilterTextValueType = 'string' | 'number';
export const allComparators = ['>=', '>', '<=', '<', '=~', '='] as const;
export type FilterTextComparator = (typeof allComparators)[number];
export const numberComparators = ['>=', '>', '<=', '<', '='];
export const stringComparators = ['=', '=~'];

export const findComparator = (
  value: string,
): FilterTextComparator | undefined =>
  allComparators.find((comparator) => {
    const valueComparator = new RegExp(`^${comparator}`, 'i');
    return valueComparator.test(value);
  });

const comparatorToApiFilterOperator = (comparator: FilterTextComparator) => {
  switch (comparator) {
    case '>=':
      return 'gte';
    case '>':
      return 'gt';
    case '<=':
      return 'lte';
    case '<':
      return 'lt';
    case '=':
      return 'eq';
    case '=~':
      return 'reg';
    default:
      return 'like';
  }
};

export const getFilterValue = (
  value: string,
  type: FilterTextValueType,
): [operator: string, value: string | number] => {
  const foundComparator = findComparator(value);

  if (!foundComparator) {
    if (type === 'string') {
      return ['like', value];
    }
    if (type === 'number') {
      const filterValue = measureUnitValueConvertor.toNumber(value.toString());

      return ['eq', filterValue];
    }
    return ['like', value];
  }
  return [
    comparatorToApiFilterOperator(foundComparator),
    value.replace(foundComparator, ''),
  ];
};
